
const initState = () => ({
})

export const state = initState

export const getters = {
}

export const mutations = {
}

export const actions = {
  async getCustomAttributesByListID({}, {customAttributeListID, filter}) {
    let customAttributes = []
    try {
      let result = await this.$axios.$get(`/webpos/custom-attribute-list/${customAttributeListID}?${new URLSearchParams(filter).toString()}`);

      if (result && result.apiMessages.hasErrors && result.apiMessages.serverErrors.length > 0) {
        this.$toast.error("Error while getting custom attributes");
      }
      else if (result.value) {
        customAttributes = result.value;
      }

    } catch (error) {
      this.$toast.error("Error while getting custom attributes");
    }
    return customAttributes;
  },

  async getCustomAttributeListByEntity({}, {customAttributeListID, entityFilter}){
    let customAttributes = []
    try{
      let result = await this.$axios.$get(`/webpos/custom-attribute-list/${customAttributeListID}/list-by-entity?${new URLSearchParams(entityFilter).toString()}`);

      if (result && result.value && !result.apiMessages.hasErrors ) {
        customAttributes = result.value;
      }
      else{
        this.$toast.error("Error while getting custom attributes");
      }

    }
    catch(error){
      this.$toast.error("Error while getting custom attributes");
    }

    return customAttributes;
  },


  async updateCustomAttributeValueForEntity({}, {customAttributeListValues, showToastMessage = true}){
    let success = true
    try{
      await this.$axios.$put(`/webpos/custom-attribute-list/entity`, customAttributeListValues);
      if(showToastMessage){
        this.$toast.success("Custom attributes updated successfully");
      }
    }
    catch(error){
      success = false;
    }
    return success;
  },
  async setCustomAttributesVisibilityByDependency({}, attributeListValues){
    let updatedCustomAttributes = []
    try{
      let result = await this.$axios.$post(`/webpos/custom-attribute-list/set-visibility-by-dependency`, attributeListValues);

      if (result && result.value && !result.apiMessages.hasErrors ) {
        updatedCustomAttributes = result.value;
      }
      else{
        this.$toast.error("Error while updating custom attributes visibility");
      }
    }
    catch(error){
      this.$toast.error("Error while updating custom attributes visibility");
    }
    return updatedCustomAttributes;
  }
}
